module.exports = __webpack_public_path__ + "media/smart_sales/benefit-3-6f40f7c8.webp";